import React, { useEffect, useState } from "react";
import styles from "./Dashboard.module.css";
import { GetDashById } from "../../../store/dash-store/dash-actions";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getTokenInfo } from "../../../utils/Guard";
import Loading from "../../../components/UI/loading/Loading";

const Dashboard = () => {
  const dispatch = useDispatch();
  const { dashid } = useParams();

  const [dashboardTitle, setDashboardTitle] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const dashboard = useSelector((state) => state.dash.dash);
  const userInfo = getTokenInfo();
  const notification = useSelector((state) => state.ui.notification);

  useEffect(() => {
    if (userInfo !== undefined && userInfo !== null && userInfo.id !== null && userInfo.id !== "" && userInfo.id !== undefined && dashid !== undefined && dashid !== null && dashid !== "") {
      dispatch(GetDashById(dashid, userInfo.id));
    }
  }, [dashid, dispatch]);


  console.log(userInfo);
  
  useEffect(() => {
    if (isLoading && dashboard !== undefined && dashboard !== null && dashboard.id !== null && dashboard.id !== "" && dashboard.id !== undefined) {
      setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    }
  }, [ dispatch, userInfo]);

    useEffect(() => {
      if (
        notification !== null &&
        notification !== undefined &&
        ((notification.status !== undefined &&
          notification.status !== null &&
          notification.status === "error") ||
          notification.status === "warning")
      ) {
        setTimeout(() => {
          window.location.href = "/";
        }, 1000);
      }
    }, [notification]);

  const dashboards = [
    { id: 1, title: "Precios y liquidez" },
    { id: 8, title: "Tasas de interés" },
    { id: 9, title: "Overnight" },
    { id: 10, title: "Tipo de cambio" },
    { id: 11, title: "Actividad económica" },
    { id: 23, title: "Coyuntura económica" },
    { id: 12, title: "Inflación y política monetaria" },
    { id: 13, title: "Crédito bancario (Banco central)" },
    { id: 14, title: "Crédito bancario (SB)" },
    { id: 21, title: "Balances e indicadores bancarios" },
    { id: 16, title: "Ciclo económico y proyecciones" },
    { id: 20, title: "PIB Sectorial" },
    { id: 18, title: "Demanda interna" },
    { id: 19, title: "Mercado laboral" },
    { id: 22, title: "Índice de confianza y de crédito" },
    { id: null, title: "Informe del sector bancario (PDF)" },
  ];

  useEffect(() => {
    const dash = dashboards.find((dash) => dash.id === parseInt(dashid));
    if (dash) {
      setDashboardTitle(dash.title);
    }
  }, [dashid]);  

  return (
    <div>
      {isLoading && (
          <Loading />
      )}

      <div className="relative z-0">
        <div className={styles.header}>
          <i
            onClick={() => (window.location.href = "/")}
            className={`pi pi-arrow-left ${styles.goBackIcon} mb-3`}
          ></i>
          <h1 className={styles.menuTitle}>{dashboardTitle}</h1>
          <h2 className={styles.menuSubtitle}>Dashboard de {dashboardTitle}</h2>
        </div>
        <iframe
          src={dashboard.link}
          className={`h-screen w-screen ${styles.iframe}`}
          allowFullScreen={true}
        ></iframe>
      </div>
    </div>
  );
};

export default Dashboard;
